import React from 'react';
import MaskedInput from 'react-text-mask';
import {isValidNumber} from 'libphonenumber-js';

import {PHONE_MASK} from '../../../constants';
import BaseInput from '../../atoms/BaseInput';

interface InputMobileProps {
  innerRef?: React.LegacyRef<MaskedInput>;
}
class InputMobile extends BaseInput<InputMobileProps> {
  isValidPhone = (phone: string): void => {
    if (typeof phone === 'undefined') {
      this.validState(true);

      return;
    }

    const isValid = isValidNumber(phone, 'US');

    this.validState(isValid);
  };

  handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const {onChange} = this.props;

    this.isValidPhone(e.target.value);

    onChange?.(e);
  };

  render(): React.ReactElement {
    const {innerRef, id, design} = this.props;

    return (
      <MaskedInput
        id={id}
        inputMode="numeric"
        onChange={this.handleChange}
        ref={innerRef}
        guide
        mask={PHONE_MASK}
        render={(ref, renderProps) => {
          const customProps = {
            ...renderProps,
            theme: {
              label: {
                text: {margin: 0},
              },
              input: {
                wrap: {
                  minHeight: '32px',
                },
                element: {
                  letterSpacing: '5px',
                  height: '32px',
                },
              },
            },
          };

          const finalProps = design === 'fill-in' ? customProps : renderProps;

          return this.renderBaseComponent(ref, finalProps);
        }}
      />
    );
  }
}

export default InputMobile;
